import { __decorate, __extends } from "tslib";
import { CustomElement, attachLightTemplate } from '@tyler-components-web/core';
import { OMNIBAR_MENU_BUTTON_CONSTANTS } from './omnibar-menu-button-constants';
import { IconButtonComponent } from '../../icon-button';
import { TooltipComponent } from '../../tooltip';
import { IconComponent, TylerIconRegistry } from '../../icon';
import { tylIconMenu } from '@tylertech/tyler-icons/standard';
var template = require('./omnibar-menu-button.html');
var OmnibarMenuButtonComponent = /** @class */ (function (_super) {
    __extends(OmnibarMenuButtonComponent, _super);
    function OmnibarMenuButtonComponent() {
        var _this = _super.call(this) /* istanbul ignore next */ || this;
        TylerIconRegistry.define(tylIconMenu);
        return _this;
    }
    OmnibarMenuButtonComponent.prototype.initializedCallback = function () {
        attachLightTemplate(this, template);
    };
    OmnibarMenuButtonComponent = __decorate([
        CustomElement({
            name: OMNIBAR_MENU_BUTTON_CONSTANTS.elementName,
            dependencies: [
                IconButtonComponent,
                TooltipComponent,
                IconComponent
            ]
        })
    ], OmnibarMenuButtonComponent);
    return OmnibarMenuButtonComponent;
}(HTMLElement));
export { OmnibarMenuButtonComponent };
